import api from './client';
import { VaultCrypto } from '@password-manager/crypto';
import { WebCryptoProvider } from '../crypto/WebCryptoProvider';

export async function getDefaultVault() {
  const { data } = await api.get('/vaults');
  return data?.[0] || null;
}

export async function loadVaultItems(vaultKey) {
  if (!vaultKey) {
    return [];
  }

  const vault = await getDefaultVault();
  if (!vault) {
    return [];
  }

  const { data: items } = await api.get(`/vaults/${vault.id}/items`);
  const vaultCrypto = new VaultCrypto(WebCryptoProvider);

  const decryptedItems = await Promise.all(
    items.map(async (item) => {
      try {
        const plaintext = await vaultCrypto.decryptItem(item.encrypted_data, vaultKey, item.id);
        return { ...item, plaintext: JSON.parse(plaintext) };
      } catch (error) {
        return { ...item, error: true };
      }
    }),
  );

  return decryptedItems;
}

export function buildCategorySummary(items) {
  const groups = new Map();

  for (const item of items) {
    if (item.error) {
      continue;
    }

    const category = item.plaintext?.category || item.item_type || 'Uncategorized';
    const current = groups.get(category) || { name: category, count: 0, items: [] };
    current.count += 1;
    current.items.push(item);
    groups.set(category, current);
  }

  return Array.from(groups.values()).sort((left, right) => {
    if (right.count !== left.count) {
      return right.count - left.count;
    }

    return left.name.localeCompare(right.name);
  });
}
